export const seoNavBar = [
  {
    text: "SEO",
    icon: "mdi-search-web",
    to: "/page",
  },
];
